import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { languages } from '__mocks__/mockData/language-data';

const LanguageApi = [
  rest.get(`${API_ROOT}language`, (req, res, ctx) => res(ctx.json(languages))),
  rest.get(`${API_ROOT}language/1`, (req, res, ctx) => res(ctx.json(languages[0]))),
  rest.put(`${API_ROOT}language/1`, (req, res, ctx) => res(ctx.json(languages[0]))),
  rest.post(`${API_ROOT}language`, (req, res, ctx) => res(ctx.json(languages))),
  rest.delete(`${API_ROOT}language/1`, (req, res, ctx) => res(ctx.json(languages[0]))),
];
export default LanguageApi;
